import { render, staticRenderFns } from "./OverviewSaleLayout.vue?vue&type=template&id=5cfa134c&scoped=true&"
import script from "./OverviewSaleLayout.vue?vue&type=script&lang=js&"
export * from "./OverviewSaleLayout.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSaleLayout.vue?vue&type=style&index=0&id=5cfa134c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa134c",
  null
  
)

component.options.__file = "OverviewSaleLayout.vue"
export default component.exports